import { Button } from "@mui/material";


function NotificationActionButton({
  id,
  buttonColor,
  buttonTextColor,
  buttonTitle,
  outlined = false,
  hoverColor,
  hoverTextColor,
  target = "/",
  width,
  onClick
}) {

  return (
    <Button
      id={id}
      onClick={onClick}
      variant={outlined ? "outlined" : "contained"}
      sx={{
        textTransform: "none",
        borderRadius: 0,
        width: width,
        backgroundColor: outlined ? "transparent" : buttonColor,
        color: buttonTextColor,
        borderColor: buttonTextColor,
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        "&:hover": {
          backgroundColor: hoverColor,
          color: hoverTextColor,
          borderColor: hoverTextColor,
        },
        ...(outlined && {
          border: `1px solid ${buttonTextColor}`,
        }),
      }}
    >
      {buttonTitle}
    </Button>
  );
}

export default NotificationActionButton;